import $http from "@/plugins/axios"

export default {
    state: {
        listDiseaseitems: [],
    },
    getters: {
        listDiseaseitems: state => state.listDiseaseitems
    },
    actions: {
        async getListDiseaseitems({ commit }, path) {
            const response = await $http.get(path)
            commit("SET_ITEMS", response.data)
        },
    },
    mutations: {
        SET_ITEMS(state, data) {
            state.listDiseaseitems = data
        }
    }
}